import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Col } from '@luigiclaudio/ga-baseline-ui/layout';
import { H6 } from '@luigiclaudio/ga-baseline-ui/typography';
import DetailsItem from './DetailsItem';
import colorConversionUtils from '../../../utils/colorConversionUtils';

const ConversionItem = ({ conversion, conversionLabel, colorValue }) => {
    return (
        <Col xxs={12}>
            <H6 color="muted">
                <FormattedMessage id={`colorDetails.${conversionLabel}.label`} />
            </H6>
            <DetailsItem
                value={colorConversionUtils.conversionResults(conversion, colorValue)}
                copyValue={colorConversionUtils.conversionResultValue(conversion, colorValue)}
            />
        </Col>
    );
};

ConversionItem.propTypes = {
    conversion: PropTypes.func.isRequired,
    colorValue: PropTypes.string.isRequired,
    conversionLabel: PropTypes.string.isRequired,
};

export default ConversionItem;
